import { useNativePatientRequests, useSupportRequests, useSupportThread, useThreads } from '@/lib/api/hooks';

import { nativeSupportEnabled } from '@/features/native-support/types';

/**
 * Unread counts per team for the care-team messaging drawer. Support also
 * counts requests waiting on the patient — those stay badged until they
 * reply, like an unanswered question would.
 */
export function useMessagingUnread() {
  const { data: threads } = useThreads();
  const { data: supportThread } = useSupportThread();
  const native = nativeSupportEnabled();
  const { data: requests } = useSupportRequests(!native);
  const { data: nativeRequests } = useNativePatientRequests(native);
  const providers = (threads ?? []).reduce(
    (n, t) => n + (t.unread_count > 0 ? 1 : 0),
    0,
  );
  const waitingOnYou = native
    ? (nativeRequests?.requests ?? []).filter(r => r.label_key === 'waiting_on_you').length
    : (requests?.requests ?? []).filter(r => r.status === 'waiting_on_you').length;
  const support = (supportThread?.unread_count ?? 0) + waitingOnYou;
  return { providers, support, total: providers + support };
}

/**
 * The Clinic nav badge (sidebar, overflow, mobile ⋯) counts both teams, since
 * both live behind Clinic.
 */
export function useClinicNavUnread(): number {
  return useMessagingUnread().total;
}
